'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { NavSection, NavLink } from './StyledComponents';

export default function Navigation() {
  const pathname = usePathname();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const isActiveRoute = (href: string): boolean => {
    if (!isHydrated) {
      // During SSR/hydration, don't show any active states to avoid mismatch
      return false;
    }

    if (href === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(href);
  };

  return (
    <NavSection>
      <NavLink href="/" isActive={isActiveRoute('/')} prefetch={true}>
        Home
      </NavLink>
      <NavLink href="/instruments" isActive={isActiveRoute('/instruments')} prefetch={true}>
        Instruments
      </NavLink>
      <NavLink href={process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://pms.geo-dev.io/'} isActive={false}>
        Project Management
      </NavLink>
    </NavSection>
  );
}